export const safeBase64Encode = (str) => {
  try {
    // Convert Unicode string to UTF-8, then to base64
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
      return String.fromCharCode('0x' + p1);
    }));
  } catch (error) {
    console.error('Base64 encoding failed:', error);
    // Fallback: remove non-Latin1 characters
    const sanitized = str.replace(/[^\x00-\xFF]/g, '?');
    try {
      return btoa(sanitized);
    } catch (fallbackError) {
      console.error('Fallback encoding failed:', fallbackError);
      return '';
    }
  }
};

// Alternative approach using URL encoding (no base64)
export const svgToDataUrl = (svgString) => {
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`;
};
